import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(
    () => ({
      ...data,
      appointment_booking_id: props.appointmentBookingId,
      state: props.state,
    }),
    [data, props.appointmentBookingId, props.state]
  )
}
